import React from 'react';

import TopicPill from '@components/Topic/TopicFollowAndTagModal/TopicPill';

import type { SearchPageProps } from './index';

type SearchHeaderProps = Pick<SearchPageProps, 'title' | 'topRelatedEntities'>;

const SearchHeader = ({ title, topRelatedEntities }: SearchHeaderProps) => {
  return (
    <div className="mx-12 mb-12 mt-24">
      <div className="mb-24 mt-8 font-suisse-neue text-headline-sm font-bold text-grayscale-gray">
        Search results for: &ldquo;{title}&rdquo;
      </div>
      <div className="border-0 border-y border-solid border-grayscale-gray py-8 text-overline">
        Related topics
      </div>
      <div className="mt-12 flex items-center gap-16">
        {topRelatedEntities.map(({ matchingEntity, name }) => (
          <TopicPill matchingEntity={matchingEntity} key={name} topic={name} />
        ))}
      </div>
    </div>
  );
};

export default SearchHeader;
